PlayersHistoryService.$inject = ["$uibModal", "BookingFactory", "$document", 'Backoffice'];

/* @ngInject */
export function PlayersHistoryService($uibModal, BookingFactory, $document) {
    this.BookingList = BookingList;
    this.open = function open(
        player,
        online,
        tab_owes,
        from_backoffice = false,
    ) {
        $uibModal.open({
            template: require('../../views/booking/players.modal.html'),
            size: "md",
            backdrop: false,
            windowClass: `zindex ${from_backoffice ? 'backoffice-zIndex' : ''}`,
            controller: "PlayersHistoryController",
            controllerAs: "vm",
            bindToController: true,
            //appendTo: parentElem,
            resolve: {
                deps: {
                    player: player,
                    online: online ? true : false,
                    has_owes: tab_owes ? true : false
                }
            }
        });
    };

    function BookingList(API, type, online) {
        this.online = online;
        this.loading = true;
        this.loaded = false;
        this.hasMore = true;
        this.list = [];
        this._API = API;
        this._type = type;
        this.page = 1;
        this.total = '?';
        //this.totalOwes = 0;

        this.fetch = BookingList.fetch.bind(this);
        this.select = BookingList.select.bind(this);
        this.isLoaded = BookingList.isLoaded.bind(this);
        this.refresh = BookingList.refresh.bind(this);
    }

    BookingList.fetch = function () {
        var self = this;

        self.loading = true;
        self.loaded = true;

        self._API
            .customGET(self._type, {
                page: self.page,
                online: self.online
            })
            .then(function (result) {
                var res = result.plain();
                self.list = self.list.concat(
                    BookingFactory.collect.simple(res.data)
                );
                self.page = res.meta.current_page + 1;
                self.total = res.meta.total;
                if (!res.links.next) {
                    self.hasMore = false;
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
                self.loading = false;
            });
    };

    BookingList.refresh = function () {
        var self = this;

        self.loading = true;
        self.loaded = true;

        self._API
            .customGET(self._type, {
                page: 1,
                online: self.online
            })
            .then(function (result) {
                var res = result.plain();

                self.list = BookingFactory.collect.simple(res.data);
                self.page = 0;

                if (!res.links.next) {
                    self.hasMore = false;
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
                self.loading = false;
            });
    };

    BookingList.isLoaded = function () {
        return this.loaded;
    };

    BookingList.select = function () {
        if (!this.loaded) {
            this.fetch();
        }
    };
}

PlayersHistoryController.$inject = [
    "$scope",
    '$rootScope',
    "$uibModalInstance",
    "deps",
    "Club",
    "PlayersHistory",
    "CONST",
    "_",
    "alerts",
    "Backoffice",
    "User",
    "Time"
];

/* @ngInject */
export function PlayersHistoryController(
    $scope,
    $rootScope,
    $uibModalInstance,
    deps,
    Club,
    PlayersHistory,
    CONST,
    _,
    alerts,
    Backoffice,
    User,
    Time
) {
    var vm = this,
        BookingList = PlayersHistory.BookingList,
        PlayerAPI = Club.API.one("players", deps.player.id);

    vm.name = deps.player.name;
    vm.online = deps.online;
    vm.tab_selected = deps.has_owes ? 4 : 1;
    vm.player = {};
    vm.totalOwes = 0;
    vm.owes_payment_type = "cash";
    vm.toggle_all = false;
    vm.isCashOperationBlocked = Club.shouldBlockCashMovements;

    vm.close = function () {
        $uibModalInstance.close(false);
    };

    vm.current = new BookingList(PlayerAPI, "current", deps.online);
    vm.done = new BookingList(PlayerAPI, "done", deps.online);
    vm.cancelled = new BookingList(PlayerAPI, "cancelled", deps.online);
    vm.owes = new BookingList(PlayerAPI, "owes", deps.online);

    vm.payOwes = function () {
        if (Club.shouldBlockCashMovements()) {
            return;
        }
        var items = _.filter(vm.owes.list, function (item) {
            return item.selected;
        });

        var data = _.map(items, function (item) {
            return item.id;
        });

        alerts.verifyCode(null, null, User)
            .then(
                payOwes.bind(null, {
                    items: data,
                    items_data: items
                })
            )
            .catch((error) => alerts.errorHandler(error));
    };

    vm.toggleAll = function () {
        vm.toggle_all = !vm.toggle_all;
        _.forEach(vm.owes.list, function (item) {
            item.selected = vm.toggle_all;
        });
    };

    vm.calculateTotalOwes = function () {
        if (!vm.owes.isLoaded()) {
            return 0;
        }

        var sum = 0;
        var count = 0;

        angular.forEach(vm.owes.list, function (item) {
            if (item.selected) {
                count++;
                sum += item.attrs.balance_abs;
            }
        });
        vm.totalOwes = sum;
        vm.toggle_all = vm.owes.list.length == count;
        return sum;
    };

    vm.rank = {
        loading: false,
        loaded: false,
        error: null,
        fetch: function () {
            var self = vm.rank;

            self.loading = true;

            PlayerAPI.customGET("rank", {
                online: vm.online
            })
                .then(function (result) {
                    self.loaded = true;
                    self.total = result.total;
                    self.club = result.club;
                })
                .catch(function (err) {
                    self.error = err;
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        select: function () {
            if (!this.loaded && !this.loading) {
                this.fetch();
            }
        },
    };

    async function payOwes(data, { code, user_info, new_access_token }) {

        data.code = code;
        data.payment_type = vm.owes_payment_type;

        let movements_owes = [];

        data.items_data.forEach((item) => {
            const created_by = {
                user: user_info?.name ?? User.data.name,
                player: item.attrs?.user?.name || '',
            };

            // booking_date es la hora de pared del club. La relevamos tal cual
            // (solo cambiamos el separador a "T" para que sea ISO válido). NO la
            // pasamos por Time.moment(): eso le estamparía el offset del
            // dispositivo y el Reloj Central la mostraría corrida cuando el huso
            // del dispositivo difiere del huso del club.
            const bookingWallClock = item.last_done?.datetime
                ? item.last_done.datetime.replace(' ', 'T')
                : Time.moment().toISOString(true);

            const concept_details = {
                booking_date: bookingWallClock,
                court: item.court.name,
                booking_id: item.id,
            };

            movements_owes.push({
                value: item.attrs.balance_abs * 100,
                concept: 'Cobro de deuda',
                payment_method: data.payment_type,
                comment: item?.note?.value?.text || '',
                created_by: JSON.stringify(created_by),
                movement_datetime: Time.moment().toISOString(true),
                concept_details: JSON.stringify(concept_details),
                quantity: 0,
                item_id: null,
            });
        });

        await Backoffice.api.registerCarts({
            stock_movements: [],
            cash_movements: movements_owes,
            new_access_token,
        });

        movements_owes = [];

        data.items_data = undefined;

        vm.loading = true;
        return Club.API.customPUT(
            {
                data: data
            },
            "owes/done"
        )
            .then(function () {
                vm.loading = false;
                vm.owes_payment_type = "cash";
                vm.owes.refresh();
                $rootScope.$broadcast('pay:owes', {
                    bookingIds: [...data.items],
                });
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }
}

BookingCompressedDirective.$inject = ["Time"];

export function BookingCompressedDirective(Time) {
    var directive = {
        link: link,
        template: require('../../views/booking/bookings.compressed.directive.html'),
        restrict: "A",
        scope: {
            index: "@",
            booking: "=",
            owes: "="
        }
    };

    return directive;

    function link(scope, element) {
        var booking = scope.booking;

        scope.hasBookeable =
            !!booking.bookeable && booking.bookeable.duration;

        scope.hasCreator = !!booking.getCreator();

        scope.isCancelled = booking.isCancelled();

        scope.isDone = !scope.isCancelled && !!booking.done;

        scope.isOwes = scope.owes;

        scope.bid = booking.id;
        scope.bookeable = {};
        scope.cancelled = {};
        scope.done = {};
        scope.creator = {};
        scope.created_at = booking
            .getCreatedAt()
            .format("DD/MM/YYYY HH:mm");

        scope.type_format = booking.isOnline()
            ? "online"
            : booking.isFixed()
                ? "fijo"
                : "unico";
        scope.type_class = booking.isOnline()
            ? "online"
            : booking.isFixed()
                ? "fixed"
                : "once";

        element.addClass(
            'callout callout-' +
                scope.type_class +
                ' callout-' +
                (booking.getType()?.code ?? ''),
        );

        scope.title =
            (booking.isFixed() ? "Los " : "El ") + booking.getDateString();

        scope.courtName = booking.getCourt() ? booking.getCourt().name : '-';
        scope.sportName = booking.getSport() ? booking.getSport().name : '-';
        scope.balance = booking.attrs.balance;

        // Booking note
        if (booking.note.value != null) {
            var note = booking.note.value;
            scope.note = note.text + " - by " + note.by;
        }

        // Bookeable behaviour
        if (scope.hasBookeable) {
            scope.bookeable.duration = booking.attrs.duration || 0;
        }

        // Creator behaviour
        if (scope.hasCreator) {
            scope.creator.name = booking.getCreator().name;
        }

        if (scope.isCancelled) {
            // Cancelled behaviour
            element.addClass("callout-cancelled");
            var datetime = Time.moment(booking.done.datetime).format(
                "DD/MM/YYYY HH:mm"
            );
            scope.title = "Cancelado (" + datetime + ")";
            scope.cancelled.reason = booking.done.feedback;
            scope.cancelled.online = !!booking.done.cancelled_online;
            scope.cancelled.reported = !!booking.done.reported;
            scope.cancelled.price = booking.done.price;
            scope.cancelled.user =
                !scope.cancelled.online && booking.done.done_user
                    ? booking.done.done_user.name
                    : false;
        } else if (scope.isDone) {
            // Done behaviour
            element.addClass("callout-done");
            var datetime = Time.moment(booking.done.datetime).format(
                "DD/MM/YYYY HH:mm"
            );
            scope.title = "Cobrado " + datetime;
            scope.done.price = booking.done.price;
            scope.done.user = booking.done.done_user
                ? booking.done.done_user.name
                : "-";
            scope.done.at = Time.moment(booking.done.done_at).format(
                "DD/MM/YYYY HH:mm"
            );
        }

        if (scope.isOwes) {
            // Done behaviour
            element.addClass("callout-done");
            scope.booking = booking;
            scope.done.price = booking.last_done.price;
            scope.done.user = booking.last_done.done_user
                ? booking.last_done.done_user.name
                : "-";
            scope.done.at = Time.moment(booking.last_done.done_at).format(
                "DD/MM/YYYY HH:mm"
            );
        }
    }
}

StatQualifierDirective.$inject = [];

/* @ngInject */
export function StatQualifierDirective() {
    var directive = {
        link: link,
        restrict: "A",
        scope: {
            value: "=statQualifier"
        }
    };
    return directive;

    function link(scope, element, attrs) {
        var limit = parseInt(attrs.limit) || 0;
        if (!attrs.inverse) {
            element.css(
                "color",
                scope.value < limit ? attrs.warningColor || "red" : "green"
            );
        } else {
            element.css(
                "color",
                scope.value > limit ? attrs.warningColor || "red" : "green"
            );
        }
    }
}
